import { aiPlanningPlanEntrypoint } from '@jira/spa-apps__ai-planning/src/aiPlanningPlanEntrypoint.entrypoint.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { softwarePlannerClassicPlanRoute } from '@jira/router-routes__software-ai-planning-routes/src/softwarePlannerClassicPlanRoute.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import type { Route } from '@atlassian/react-resource-router';

const aiPlanningClassicSoftwarePlanPageEntrypoint = createChromelessEntryPoint({
	main: aiPlanningPlanEntrypoint,
});

export const softwarePlannerClassicPlanRouteEntry: Route = createEntry(
	softwarePlannerClassicPlanRoute,
	() => ({
		group: 'classic-software',
		ufoName: 'software-planner-classic-plan',
		layout: { isChromeless: true, globalComponents: [], rightSidebars: [] },
		resources: [],

		meta: {
			reporting: {
				id: 'software-planner-classic-plan',
				packageName: 'jiraRouterRoutesSoftwareAiPlanningEntries',
				teamName: 'Dev AI - Planner',
			},
		},

		entryPoint: () =>
			// eslint-disable-next-line jira/ff/no-preconditioning -- temporary route handoff requires both the Planner tab gate and route-rename gate.
			fg('jira_ai_planner_tab') && fg('ai-planner-jira-monolith-route-rename')
				? aiPlanningClassicSoftwarePlanPageEntrypoint
				: notFoundPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
